import * as React from "react";

const NotificationsIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 190 190" {...props}>
		<path d="M94.43 128.98c-23.55 0-47.09-.07-70.64.06-4.14.02-5.27-.53-3.54-4.32 11.26-22.14.53-46.88 10.37-69.22 14.91-34.74 43.19-30.13 47.79-42.41 3.38-16.24 29.97-15.99 33.14 0 .81 3.81 3.26 5.39 7.53 6.99 63.12 25.73 34.37 62.36 50.77 105.12 1.53 3.69.32 3.82-3.09 3.81-24.11-.06-48.23-.03-72.35-.03ZM119.55 159.01c11.19 40.18-59.93 39.63-49.48.49-19.63-1.38-40.02-.02-59.91-.49-5.76 0-9.23-2.97-9.15-7.72.07-4.39 3.62-7.28 9.09-7.28 56.57-.01 113.14 0 169.71 0 5.77 0 9.26 2.96 9.19 7.69-.06 4.43-3.57 7.31-9.05 7.31h-60.39Z" />
	</svg>
);

export default NotificationsIcon;
